import { FormattedPost } from "@/lib/blog";
import PostCard from "./PostCard";

function Posts({ posts = [] }: PostsProps) {
  const renderedPosts = posts.map((post) => (
    <PostCard key={post.id} post={post} />
  ));

  return <div className="row">{renderedPosts}</div>;
}

interface PostsProps {
  posts?: FormattedPost[];
}

export default Posts;
